/* RAKNIDA · assets/rk-trade-size.js — small (S) prints are always full price (DEC-457, 27 Oct 2026).
   The shop app (rk-shop-app.js — never edited) turns the catalogue into its own product list in window.RK_ADAPT, and
   gives every size of a work the work's one trade percentage. This file wraps RK_ADAPT the moment it is defined and
   puts each S size back to its list price, so a trade buyer sees exactly what checkout charges: M and up discounted,
   S at full price. Everything else the app builds is untouched.
   S = a size whose long side is 12 in or less, read from the variant title: its first two numbers, both 12 or less —
   the same rule as snippets/rk-trade-tier.liquid and the Projects app (app/lib/quote.js). The data sections send the
   tier's percentage from the work's largest size, so M and up keep their discount.
   Loaded in <head> (layout/theme.liquid), before any copy of the app, including the one rk-card-qv.js adds later. */
(function (w) {
  if (!w || w.__RK_TS) return;
  w.__RK_TS = 1;
  function small(t) {
    var m = String(t == null ? '' : t).match(/\d+(?:\.\d+)?/g);
    return !!(m && m.length >= 2 && Math.max(+m[0], +m[1]) <= 12);
  }
  function fix(out, data) {
    try {
      var sm = {};
      ((data && data.products) || []).forEach(function (r) {
        (r.variants || []).forEach(function (v) { if (small(v.title)) sm[String(v.id)] = 1; });
      });
      (out || []).forEach(function (p) {
        var s = p && p.sizesReal;
        if (!s || !s.length) return;
        var ch = false;
        s.forEach(function (z) {
          if (!sm[String(z.vid)]) return;
          z.small = true;
          if (z.rp != null && z.p !== z.rp) { z.p = z.rp; ch = true; }
        });
        if (ch) {
          p.p = s[0].p;
          p.maxP = s[s.length - 1].p;
          p.retail = s[0].rp != null && s[0].p < s[0].rp ? s[0].rp : null;
        }
      });
    } catch (e) { /* never break the shop over a price display */ }
    return out;
  }
  function wrap(fn) {
    if (typeof fn !== 'function' || fn.__rkts) return fn;
    var g = function (data) { return fix(fn.apply(this, arguments), data); };
    g.__rkts = 1;
    return g;
  }
  var cur = wrap(w.RK_ADAPT);
  try {
    Object.defineProperty(w, 'RK_ADAPT', { configurable: true, enumerable: true,
      get: function () { return cur; }, set: function (v) { cur = wrap(v); } });
  } catch (e) { if (cur) w.RK_ADAPT = cur; }
})(typeof window !== 'undefined' ? window : null);
